    (() => {
  function normalizeQuantity(formData, form) {
    formData.delete('quantity');
    const qtyInput =
      form.querySelector('[name="quantity"]') ||
      document.querySelector('.quantity__input');
    const quantity = qtyInput && qtyInput.value ? qtyInput.value : 1;
    formData.set('quantity', quantity);
  }
  const originalFetch = window.fetch;
  window.fetch = function (url, config) {
    if (
      typeof url === 'string' &&
      url.includes('/cart/add') &&
      config?.body instanceof FormData
    ) {
      const form = document.querySelector('form[data-type="add-to-cart-form"]');
      if (form) {
        normalizeQuantity(config.body, form);
      }
    }
    return originalFetch.apply(this, arguments);
  };
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!form.matches('form[data-type="add-to-cart-form"]')) return;
      const qtyInputs = form.querySelectorAll('[name="quantity"]');
      if (qtyInputs.length > 1) {
        qtyInputs.forEach((input, index) => {
          if (index < qtyInputs.length - 1) input.remove();
        });
      }
    },
    true
  );
})();